import { DraftBasketType } from './types';

export const initialState: DraftBasketType = {
  basket: [],
};
